import React, { useState, useRef, useEffect } from "react";


export default function Illustration() {

    var sectionStyle1 = 'Page 27.jpg'
    var sectionStyle2 = 'PAGE 01.jpg'
    var sectionStyle3 = 'illustration195.jpg'
    var sectionStyle4 = 'illustration196.jpg'
    var sectionStyle5 = 'illustration166.jpg'
    var sectionStyle6 = 'illustration208.jpg'
    var sectionStyle7 = 'illustration204.jpg'
    var sectionStyle8 = 'illustration198.jpg'
 

    var sections = [ sectionStyle1, sectionStyle2, sectionStyle3, sectionStyle4, sectionStyle5,sectionStyle6,sectionStyle7,sectionStyle8]

    const [toggle, setToggle] = useState(false)
    var [sectionStyle, setStyle] = useState([sections[0]])
    
    
    return (
        <>
            <div className="parent">
                <div className="chd5" >
                    <a href="/"><button  className="left-slide"><img src="back_arrow.svg" /></button></a>
                    <p className="ill">illustrations</p>
                    <div className="enlarged"><img src={sectionStyle}/></div>
                    <ul className="corner_left">
                        <li onClick={ (e) => setStyle(sectionStyle1) } ><img src={sections[0]}/></li>
                        <li onClick={ (e) => setStyle(sectionStyle2) } ><img src={sections[1]}/></li>
                        <li onClick={ (e) => setStyle(sectionStyle3) } ><img src={sections[2]}/></li>
                        <li onClick={ (e) => setStyle(sectionStyle4) }><img src={sections[3]}/></li>
                    </ul>

                    <ul className="corner_right">
                        <li onClick={ (e) => setStyle(sectionStyle5) } ><img src={sections[4]}/></li>
                        <li onClick={ (e) => setStyle(sectionStyle6) } ><img src={sections[5]}/></li>
                        <li onClick={ (e) => setStyle(sectionStyle7) } ><img src={sections[6]}/></li>
                        <li onClick={ (e) => setStyle(sectionStyle8) }><img src={sections[7]}/></li>
                    </ul>

                </div>
            </div>
        </>
    );
}